import { Button } from "primereact/button";
import { useState, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { TabPanel, TabView } from "primereact/tabview";
import { delimitationService } from "../services/DelimitationService";
import { Tree } from "primereact/tree";
import { get } from "lodash";
import { usersService } from "../services/UsersService";

export default function OfficeSelector({ show = false, selectedUser, userDelimitations, onHide, onSubmit }) {
	const [loading, setLoading] = useState(false);
	const [offices, setOffices] = useState([]);
	const [selectedOffice, setSelectedOffice] = useState(null);

	const toast = useRef(null);

	var [district, setDistrict] = useState("");

	var [nodes, setNodes] = useState([]);
	var [selectedKeys, setSelectedKeys] = useState({});
	var [oldSelectedKeys, setOldSelectedKeys] = useState({});
	var [manualSelectedPolDivision, setManualSelectedPolDivision] = useState([]);

	function getPreSelectedIds() {
		let ids = {};

		userDelimitations.forEach((d) => {
			if (d.delimitationLevelID === 1) {
				// District fully checked
				ids[`1-${d.districtID}`] = { checked: true, partialChecked: false };
			}
			else if (d.delimitationLevelID === 2) {
				// Constituency checked
				ids[`2-${d.constituencyID}-${d.districtID}`] = { checked: true, partialChecked: false };

				// Mark parent as partial (if not fully checked yet)
				if (!ids[`1-${d.districtID}`]) {
					ids[`1-${d.districtID}`] = { checked: false, partialChecked: true };
				}
			}
		});

		return ids;
	}

async function getOfficesAndPreselect(userId) {
    setLoading(true);
    try {
        const officesData = await usersService.getOffices(userId);
        const districtsData = await delimitationService.getDistricts(); // all districts
        let preKeys = {};

        for (const office of officesData) {
            if (office.delimitationLevelID === 1) {
                // Whole district selected
                preKeys[`1-${office.delimitationID}`] = { checked: true, partialChecked: false };
            } 
            else if (office.delimitationLevelID === 2) {
                let foundDistrictId = null;

                // Search for the district containing this constituency
                for (const district of districtsData) {
                    const constituencies = await delimitationService.getConstituenciesByDistrict(district.id);
                    const match = constituencies.find(c => c.id === office.delimitationID);
                    if (match) {
                        foundDistrictId = district.id;
                        break;
                    }
                }

                if (foundDistrictId) {
                    const childKey = `2-${office.delimitationID}-${foundDistrictId}`;
                    preKeys[childKey] = { checked: true, partialChecked: false };

                    // Mark district as partial if not already fully selected
                    if (!preKeys[`1-${foundDistrictId}`]) {
                        preKeys[`1-${foundDistrictId}`] = { checked: false, partialChecked: true };
                    }
                }
            }
        }

        setSelectedKeys(preKeys);
        setOldSelectedKeys(preKeys);
    } catch (err) {
        console.error(err);
    } finally {
        setLoading(false);
    }
}





	function PreselectActiveDelimitationNodes(key) {
		setSelectedKeys(getPreSelectedIds());
		setOldSelectedKeys(getPreSelectedIds());
	}
	function getDistricts() {
		setLoading(true);
		try {
			delimitationService.getDistricts().then((response) => {
				var districts = [];
				response.forEach((e) => {
					districts.push({
						key: "1-" + e.id,
						label: e.code + " - " + e.name,
						checked: true,
						leaf: false
					});
				});
				setNodes(districts);
				//setLoading(false);
			});
		} catch (error) {
			setLoading(false);
		}
	}

	function isValid() {
		return district !== "";// && constituency !== "" && pollingDivision !== "" && registrationCentre !== "";
	}



	function getAllChildKeys(node) {
		let keys = [];
		if (node.children && node.children.length) {
			node.children.forEach(child => {
				keys.push(child.key);
				keys = keys.concat(getAllChildKeys(child));
			});
		}
		return keys;
	}

	function findNodeByKey(data, key) {
		for (let node of data) {
			if (node.key === key) return node;
			if (node.children) {
				const found = findNodeByKey(node.children, key);
				if (found) return found;
			}
		}
		return null;
	}

	function submit() {
		setLoading(true);

		const payload = Object.keys(selectedKeys)
			.filter(k => selectedKeys[k]?.checked)
			.filter(k => k.startsWith("2-")) // only constituencies
			.map(k => {
				const [, id] = k.split("-");
				return {
					UserID: selectedUser.userID,
					DelimitationID: id,
					DelimitationLevelID: 2
				};
			});

		onSubmit(payload);
	}



	function SetSelectedNodesIds(value) {
		setSelectedKeys(value);
	}

	function ResponseToChildren(response, level, parentID) {
		var children = [];

		response.forEach((e) => {
			children.push({
				key: level + "-" + e.id + "-" + parentID,
				label: e.code + " - " + e.name,
				leaf: level == 2 ? true : false
			});
		});

		return children;
	}

	//when selecting the last level(voting station) node on the tree and if that node is the only child,
	//the parent is fully selected which will mean the person being added will have access to the parent(voting district) 
	//wich will include every station in it. This logic is to keep track of those manually selectd station to avoid that.
	const onSelect = (event) => {
		if (oldSelectedKeys[event.node.key]) {
			delete (oldSelectedKeys[event.node.key]);
			setOldSelectedKeys(oldSelectedKeys);
		}
		if (event.node.key.split("-")[0] == 3 && !manualSelectedPolDivision.find((x) => x.key == event.node.key)) {
			manualSelectedPolDivision.push(event.node.key);
		}
	};
	const onUnselect = (event) => {
		var keyIndex = manualSelectedPolDivision.indexOf(event.node.key);
		if (event.node.key.split("-")[0] == 3 && keyIndex >= 0) {
			manualSelectedPolDivision.splice(keyIndex);
		}
	};

	function PreselectOnExpand(node) {
		if (selectedKeys[node.key] && selectedKeys[node.key].checked) {
			var ids = { ...selectedKeys }
			node.children.forEach((e) => {
				if (!selectedKeys[e.key]) {
					ids[e.key] = { checked: true, partialChecked: false };
				}
			});
			setSelectedKeys(ids);
		}
	}
	async function handleSelectionChange(e) {
		const prev = selectedKeys;
		let next = { ...e.value };

		// Which keys became checked just now?
		const newlyChecked = Object.keys(next).filter(k => !(prev[k]?.checked) && next[k]?.checked);
		// Which keys became unchecked just now?
		const newlyUnchecked = Object.keys(prev).filter(k => prev[k]?.checked && !next[k]);

		// Handle newly CHECKED districts → ensure children are loaded & checked
		for (const key of newlyChecked) {
			const [level, districtId] = key.split("-");
			if (level === "1") {
				// find district node
				let node = findNodeByKey(nodes, key);
				if (!node) continue;

				// lazily load children if needed
				if (!node.children || node.children.length === 0) {
					const resp = await delimitationService.getConstituenciesByDistrict(districtId);
					node.children = ResponseToChildren(resp, 2, districtId);
					setNodes(n => [...n]); // trigger re-render
				}

				// select all children
				const childKeys = getAllChildKeys(node);
				childKeys.forEach(childKey => {
					next[childKey] = { checked: true, partialChecked: false };
				});
			}
		}

		// Handle newly UNCHECKED districts → remove all children from selection
		for (const key of newlyUnchecked) {
			const [level] = key.split("-");
			if (level === "1") {
				const node = findNodeByKey(nodes, key);
				if (node) {
					const childKeys = getAllChildKeys(node);
					childKeys.forEach(childKey => {
						delete next[childKey];
					});
				}
			}
		}

		setSelectedKeys(next);
	}

	function NodeExand(e) {
		var keys = e.node.key.split("-");
		var parentID = keys[1];
		var level = keys[0];

		if (level == 1) {
			delimitationService.getConstituenciesByDistrict(parentID).then((response) => {
				e.node.children = ResponseToChildren(response, 2, parentID);
				let value = [...nodes];
				setNodes(value);
				//adjust the visual selection of the nodes after expanding. This eclude childre if the for example, 
				//the parent node is fully selected because the user delimitation is used to select.
				PreselectOnExpand(e.node);


			});
		}
	}

	return (
		<Dialog
			draggable={false}
			header={
				<>
					<span>Select User Office</span>
				</>
			}
			footer={
				<>
					<Button onClick={submit} className="p-button-primary" type="button" label="Submit" disabled={isValid() || loading} />
					<Button onClick={onHide} className="p-button-danger" type="button" label="Cancel" />
				</>
			}
			visible={show}
			onHide={(e) => {
				onHide();
			}}
			onShow={() => {
				setNodes([]);
				setSelectedKeys({});
				setOldSelectedKeys({});
				getDistricts();
				getOfficesAndPreselect(selectedUser.userID);
			}}
		>
			<div className="grid">
				<div className="col-12 lg:col-12">
					<Toast ref={toast} />
					<form>
						<TabView>
							<TabPanel>
								<Tree
									loading={loading}
									value={nodes}
									selectionMode="checkbox"
									selectionKeys={selectedKeys}
									onSelectionChange={handleSelectionChange}
									onExpand={(e) => NodeExand(e)}
									propagateSelectionDown={false}
									propagateSelectionUp={false}
									className="w-full"
								/>
							</TabPanel>
						</TabView>
					</form>
				</div>
			</div>
		</Dialog>
	);
}
